import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PrivateRoute from './private-route';
import { LoginPath, DashboardPath, AIAssistantPath, WorkingEfficienyPath, MovementEfficienyPath, UsageEfficienyPath, LoadEfficienyPath, AdminViewPath, RealTimeMapViewPath, ComparisionAnalysisPath, RawDataPath, HeatmapPath, EfficiencySummaryPath, EfficiencySummaryV2Path, ShiftMovementSummaryPath, OperatorComparingSummaryPath, AlarmsPath, AlarmReportsPath, AlarmSetsPath, IndoorManagementPath, VenueManagementPath, UserSettingsPath, UserAggrementPath, SignUpPath, TrnaslationsPath, BatteryPath, PrivacyPolicyPath, ForkliftDetailPath, WorkingHoursPath, BulkForkliftPath, BulkDevicePath, BulkOperatorPath, BulkUserPath, BulkBatteryPath, EmailPath, AppConfigPath, GeofencingRegionManagementPath, AuditPath, AIConfigPath, MaintenanceLogPath, AppStatusPath, PlanningPath, OperatorSummaryPath, DailyEfficiencySummaryPath, UnauthorizedUsagePath, AiReportsPath, AiGuidePath, AiTokenUsagePath, BreachPath, SafetyPath, IndoorMapsPath } from './path'
import PublicRoute from './public-route';
import { ConfigProvider, Spin, theme } from 'antd';
import enUS from 'antd/locale/en_US';
import trTR from 'antd/locale/tr_TR';
import { useSelector } from 'react-redux';
import { selectIsLightTheme, selectLang } from '../shared/global-store/global.selectors';
import { LoadingOutlined } from '@ant-design/icons';
import { EfficienyType } from '../shared/enums/efficiencyType.enum';

import dayjs from 'dayjs';
import ErrorBoundary from '../shared/components/error-boundary/error-boundary';

require('dayjs/locale/de')
require('dayjs/locale/tr')
require('dayjs/locale/en')

const Login = React.lazy(() => import('../pages/utillity-pages/login/login'))
const Dashboard = React.lazy(() => import('../pages/utillity-pages/dashboard/dashboard'))
const AIAssistant = React.lazy(() => import('../pages/ai-assistant/ai-assistant'))
const Efficiency = React.lazy(() => import('../pages/efficiencies/efficiency/efficiency'))
const AdminView = React.lazy(() => import('../pages/admin-pages/admin-view/admin-view'))
const RealTimeMapView = React.lazy(() => import('../pages/efficiencies/real-time-map-view/realTimeMapView'))
const ComparisionAnalysis = React.lazy(() => import('../pages/efficiencies/comparision-analysis/comparisionAnalysis'))
const NotFound = React.lazy(() => import('../pages/utillity-pages/not-found/not-found'))
const RawView = React.lazy(() => import('../pages/admin-pages/raw/raw'))
const HeatmapView = React.lazy(() => import('../pages/efficiencies/heatmap/heatmap'))
const EfficiencySummaryView = React.lazy(() => import('../pages/efficiencies/efficiency-summary/efficiencySummary'))
const EfficiencySummaryV2View = React.lazy(() => import('../pages/efficiencies/efficiency-summary-v2/efficiencySummary'))
const OperatorAnalysis = React.lazy(() => import('../pages/operators/operator-analysis/operatorAnalysis'))
const OperatorComparing = React.lazy(() => import('../pages/operators/operator-comparing/operatorComparing'))
const OperatorList = React.lazy(() => import('../pages/operators/operator-list/operatorList'))
const AlarmTable = React.lazy(() => import('../pages/alarms/alarm-table/alarm-table'))
const AlarmReports = React.lazy(() => import('../pages/alarms/alarm-report/alarm-reports'))
const AlarmSets = React.lazy(() => import('../pages/alarms/alarm-sets/alarm-sets'))
const IndoorManagement = React.lazy(() => import('../pages/admin-pages/indoor-management/indoor-management'))
const VenueManagement = React.lazy(() => import('../pages/admin-pages/venue-management/venue-management'))
const UserSettings = React.lazy(() => import('../pages/utillity-pages/user-settings/userSettings'))
const KVKK = React.lazy(() => import('../pages/utillity-pages/user-aggrement/kvkk'))
const Signup = React.lazy(() => import('../pages/utillity-pages/sign-up/signup'))
const Translations = React.lazy(() => import('../pages/admin-pages/translations/translation'))
const Battery = React.lazy(() => import('../pages/batteries/battery/battery'))
const PrivacyPolicy = React.lazy(() => import('../pages/utillity-pages/privacy-policy/privacy-policy'))
const ForkliftDetail = React.lazy(() => import('../pages/forklift/detail/detail'))
const WorkingHours = React.lazy(() => import('../pages/working-hours/workingHours'))
const BulkForklift = React.lazy(() => import('../pages/admin-pages/bulk-forklift/bulk-forklift'))
const BulkDevice = React.lazy(() => import('../pages/admin-pages/bulk-device/bulk-device'))
const BulkOperator = React.lazy(() => import('../pages/admin-pages/bulk-operator/bulk-operator'))
const BulkUser = React.lazy(() => import('../pages/admin-pages/bulk-user/bulk-user'))
const BulkBattery = React.lazy(() => import('../pages/admin-pages/bulk-battery/bulk-battery'))
const Email = React.lazy(() => import('../pages/admin-pages/email/email'))
const EmailDetails = React.lazy(() => import('../pages/admin-pages/email/email-details'))
const AppConfig = React.lazy(() => import('../pages/admin-pages/app-config/app-config'))
const AIConfig = React.lazy(() => import('../pages/admin-pages/ai-config/ai-config'))
const GeofencingRegion = React.lazy(() => import('../pages/geofencing-management/geofencing-region'))
const Audit = React.lazy(() => import('../pages/admin-pages/audit/audit'))
const MaintenanceLog = React.lazy(() => import('../pages/maintenance-logs/maintenance-log'))
const AppStatus = React.lazy(() => import('../pages/app-status/app-status'))
const AiPlanning = React.lazy(() => import('../pages/ai-assistant/ai-planning/ai-planning'))
const AiReportsPage = React.lazy(() => import('../pages/ai-assistant/ai-reports/ai-reports'))
const AiGuidePage = React.lazy(() => import('../pages/ai-assistant/ai-guide/ai-guide'))
const DailyEfficiencySummaryView = React.lazy(() => import('../pages/efficiencies/daily-efficiency-summary/dailyEfficiencySummary'))
const UnauthorizedUsage = React.lazy(() => import('../pages/operators/unauthorized-usage/unauthorizedUsage'))
const AiTokenUsage = React.lazy(() => import('../pages/admin-pages/ai-token-usage/ai-token-usage'))
const SafetyDashboard = React.lazy(() => import('../pages/safety/dashboard/dashboard'))
const SafetyBreach = React.lazy(() => import('../pages/safety/breach/breach'))
const IndoorMaps = React.lazy(() => import('../pages/indoor-maps/indoor-maps'))

const App: React.FC = () => {

    const selectedLang = useSelector(selectLang);
    const isLightTheme = useSelector(selectIsLightTheme);

    useEffect(() => {
        dayjs.locale(selectedLang);
    }, []);

    return(
        <>
            <ConfigProvider locale={selectedLang === "tr" ? trTR : enUS} theme={
                {
                    algorithm: isLightTheme ? theme.defaultAlgorithm : theme.darkAlgorithm,
                    token: {
                        colorPrimary: isLightTheme ? '#FF7801' : '#FF9900',
                        colorLink: isLightTheme ? '#FF7801' : '#FF9900'
                    }, 
                    components: {
                        Layout: {
                          siderBg: isLightTheme ? '#FFF' : '#141414',
                          triggerBg: isLightTheme ? '#FFF' : '#141414',
                          lightSiderBg: isLightTheme ? '#FFF' : '#141414',
                          lightTriggerBg: isLightTheme ? '#FFF' : '#141414',
                          headerBg: isLightTheme ? '#FFF' : '#141414',
                        },
                        Menu: {
                            darkItemBg: isLightTheme ? '#FFF' : '#141414',
                            itemBg: isLightTheme ? '#FFF' : '#141414',
                            darkSubMenuItemBg: isLightTheme ? '#f6f6f6' : '#373737',
                            subMenuItemBg: isLightTheme ? '#f6f6f6' : '#373737',
                        }
                    },
                }
            }>
                <BrowserRouter>
                    <Suspense fallback={<Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} className="w-screen h-screen flex justify-center items-center" style={{backgroundColor: isLightTheme ? '#FFF' : '#000'}} />}>
                    <ErrorBoundary>
                    <Routes>
                        <Route path={"/"} element={<PrivateRoute />}>
                            <Route path={DashboardPath} element={<Dashboard />} />
                            <Route path={AIAssistantPath} element={<AIAssistant />} />
                            <Route path={ComparisionAnalysisPath} element={<ComparisionAnalysis />} />
                            <Route path={WorkingEfficienyPath} element={<Efficiency efficienyType={EfficienyType.Working} />} />
                            <Route path={MovementEfficienyPath} element={<Efficiency efficienyType={EfficienyType.Movement} />} />
                            <Route path={UsageEfficienyPath} element={<Efficiency efficienyType={EfficienyType.Usage} />} />
                            <Route path={LoadEfficienyPath} element={<Efficiency efficienyType={EfficienyType.Load} />} />
                            <Route path={AdminViewPath} element={<AdminView />} />
                            <Route path={RealTimeMapViewPath} element={<RealTimeMapView />} />
                            <Route path={RawDataPath} element={<RawView />} />
                            <Route path={HeatmapPath} element={<HeatmapView />} />
                            <Route path={EfficiencySummaryPath} element={<EfficiencySummaryView />} />
                            <Route path={EfficiencySummaryV2Path} element={<EfficiencySummaryV2View />} />
                            <Route path={ShiftMovementSummaryPath} element={<OperatorAnalysis />} />
                            <Route path={OperatorComparingSummaryPath} element={<OperatorComparing />} />
                            <Route path={AlarmsPath} element={<AlarmTable />} />
                            <Route path={AlarmReportsPath} element={<AlarmReports />} />
                            <Route path={AlarmSetsPath} element={<AlarmSets />} />
                            <Route path={IndoorManagementPath} element={<IndoorManagement />} />
                            <Route path={VenueManagementPath} element={<VenueManagement />} />
                            <Route path={UserSettingsPath} element={<UserSettings />} />
                            <Route path={TrnaslationsPath} element={<Translations />} />
                            <Route path={BatteryPath} element={<Battery />} />
                            <Route path={WorkingHoursPath} element={<WorkingHours />} />
                            <Route path={BulkForkliftPath} element={<BulkForklift />} />
                            <Route path={BulkDevicePath} element={<BulkDevice />} />
                            <Route path={BulkOperatorPath} element={<BulkOperator />} />
                            <Route path={BulkUserPath} element={<BulkUser />} />
                            <Route path={BulkBatteryPath} element={<BulkBattery />} />
                            <Route path={AppConfigPath} element={<AppConfig />} />
                            <Route path={AIConfigPath} element={<AIConfig />} />
                            <Route path={EmailPath} element={<Email />} />
                            <Route path={EmailPath + '/:id'} element={<EmailDetails />} />
                            <Route path={ForkliftDetailPath + '/:name'} element={<ForkliftDetail />} />
                            <Route path={GeofencingRegionManagementPath} element={<GeofencingRegion />} />
                            <Route path={AuditPath} element={<Audit />} />
                            <Route path={MaintenanceLogPath} element={<MaintenanceLog />} />
                            <Route path={AppStatusPath} element={<AppStatus />} />
                            <Route path={PlanningPath} element={<AiPlanning />} />
                            <Route path={AiReportsPath} element={<AiReportsPage />} />
                            <Route path={AiGuidePath} element={<AiGuidePage />} />
                            <Route path={OperatorSummaryPath} element={<OperatorList />} />
                            <Route path={DailyEfficiencySummaryPath} element={<DailyEfficiencySummaryView />} />
                            <Route path={UnauthorizedUsagePath} element={<UnauthorizedUsage />} />
                            <Route path={AiTokenUsagePath} element={<AiTokenUsage />} />
                            <Route path={SafetyPath} element={<SafetyDashboard />} />
                            <Route path={BreachPath} element={<SafetyBreach />} />
                            <Route path={IndoorMapsPath} element={<IndoorMaps />} />
                            <Route element={<NotFound />} />
                        </Route>

                        <Route path="/" element={<PublicRoute />}>
                            <Route path={LoginPath} element={<Login />} />
                            <Route path={UserAggrementPath} element={<KVKK />} />
                            <Route path={SignUpPath} element={<Signup />} />
                            <Route path={PrivacyPolicyPath} element={<PrivacyPolicy />} />
                        </Route>

                        <Route path="*" element={<NotFound />} />
                    </Routes>
                    </ErrorBoundary>
                    </Suspense>
                </BrowserRouter>
            </ConfigProvider>
        </>
    );
}

export default App;
